import React, { useContext, createContext } from 'react';
import type { FC, ReactNode } from 'react';

interface SiteOverride {
  siteOverrideId?: string;
}

const SiteOverrideContext = createContext<SiteOverride | null>(null);

export const SiteOverrideProvider: FC<{
  children: ReactNode;
  siteOverrideId?: string;
}> = ({ children, siteOverrideId }) => {
  return (
    <SiteOverrideContext.Provider value={{ siteOverrideId }}>
      {children}
    </SiteOverrideContext.Provider>
  );
};

export const useSiteOverrideId = () => {
  const context = useContext(SiteOverrideContext);

  if (context == null) {
    throw new Error(
      'useSiteOverrideId() cannot be used without an <SiteOverrideProvider>'
    );
  }

  return context;
};
